<script setup lang="ts">
import { cn } from "@/lib/utils";
import { X } from "lucide-vue-next";
import { ToastClose, type ToastCloseProps } from "radix-vue";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
    ToastCloseProps & {
        class?: HTMLAttributes["class"];
    }
>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>

<template>
    <ToastClose
        v-bind="delegatedProps"
        :class="
            cn(
                'right-2 top-2 rounded-md p-1 text-stone-950/50 hover:text-stone-950 group-[.destructive]:text-red-300 group-[.destructive]:hover:text-red-50 group-[.destructive]:focus:ring-red-400 group-[.destructive]:focus:ring-offset-red-600 dark:text-stone-50/50 dark:hover:text-stone-50 absolute opacity-0 transition-opacity group-hover:opacity-100 focus:opacity-100 focus:ring-2 focus:outline-none',
                props.class,
            )
        "
    >
        <X class="h-4 w-4" />
    </ToastClose>
</template>
